import React from "react";

import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/20/solid";
import booking_svg from "../assets/bookingLink.svg";
import copy_squares from "../assets/square.on.square.svg";
import { useToast } from "../provider/ToastProvider";

export default function BookingLinkModal({
  title,
  subtitle,
  errorMsg = "Sorry for the inconvenience, The Payment Link was not Generated. Please try again.",
  open, handleClose, bookingLink }) {
  const { addToast, addSuccessToast, addErrorToast } = useToast();
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      className="relative z-50"
    >
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />
      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-3xl bg-brown-coffee px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div className="absolute right-0 top-0 pr-4 pt-4 sm:block">
              <button
                type="button"
                onClick={handleClose}
                className="rounded-md bg-brown-coffee text-white hover:text-gray-500 focus:outline-none focus:ring-0 focus:ring-indigo-500 focus:ring-offset-2"
              >
                <span className="sr-only">Close</span>
                <XMarkIcon aria-hidden="true" className="size-6" />
              </button>
            </div>
            <div className="sm:flex sm:items-center">
              {bookingLink ? (<div className={"flex flex-col gap-10 p-8 pt-4 w-full"}>
                <div className={"flex flex-row items-center justify-between border-b border-light-brown-coffee pb-3"}>
                  <h3 className={"font-bold text-2xl text-white"}>{title !== undefined ? title : `Share Booking Link`}</h3>
                </div>
                <div className={"flex flex-col gap-2"}>
                  <img src={booking_svg} alt={""} />
                  <p className={"font-medium text-base text-center text-white"}>
                    {subtitle !== undefined ? subtitle : `Payment Link Generated`}
                  </p>
                </div>
                <button
                  className={
                    "sm:min-w-80 h-14 bg-white rounded-xl flex flex-row items-center gap-2 px-4 py-2"
                  }
                  onClick={async () => {
                    try {
                      await navigator.clipboard.writeText(bookingLink);
                      addSuccessToast("Copied!");
                    } catch (e) {
                      addErrorToast("Failed to copy!");
                    }
                  }}
                >
                  <span className={"grow font-semibold text-brown-coffee truncate"}>
                    {typeof bookingLink === 'string' && bookingLink.slice(0, 35)}...
                  </span>
                  <span className={"flex flex-col items-center"}>
                    <img src={copy_squares} alt={""} />
                    <p className={"text-[7px] font-semibold text-black"}>Copy</p>
                  </span>
                </button>
              </div>) : (
                <div className={"flex flex-col gap-10 p-10 w-full"}>
                  <div className={"flex flex-col gap-2"}>
                    <p className={"font-medium text-base text-center text-white"}>
                      {errorMsg}
                    </p>
                  </div>
                </div>
              )}
            </div>
          </DialogPanel>
        </div>
      </div>

    </Dialog>
  );
}